import type { Lesson } from "../../lib/lessonsApi";
import type { LibraryEntry } from "../../lib/libraryApi";

/** The prototype's `lessonStr()`: the mark a lesson carries, from its state, the owner's call, or its strength. */
export function lessonStr(l: Lesson): string {
  if (l.state === "proposed" || l.state === "rejected" || l.state === "retired") return l.state;
  return l.strength;
}

/** "medium strength", or "disputed" once the owner disputes it. */
export const strengthWords = (l: Lesson) => (l.strength === "disputed" ? "disputed" : `${l.strength} strength`);

/** A fact as a sentence, so facts read as one paragraph when joined. */
export const sentence = (s: string) => (/[.!?]$/.test(s.trim()) ? s.trim() : `${s.trim()}.`);

/** The lesson's evidence as one paragraph, the way the prototype's cards show it. */
export const evidenceText = (l: Lesson) => l.evidence.map((e) => sentence(e.fact)).join(" ");

/** The library row a lesson's skill change lands on: the account's own copy first, as the API applies it. */
export function skillEntry(skills: LibraryEntry[], name: string): LibraryEntry | null {
  const rows = skills.filter((e) => e.name === name);
  return rows.find((e) => e.origin === "account") ?? rows.find((e) => e.origin === "product") ?? rows.find((e) => e.origin === "flashadz") ?? null;
}
